import ajax from '@/libs/Ajax'

export default {
  queryPersistenTmp(params) {
    return ajax.get('/aseapi/console/sysmgr/persistpre/list', {params: params})
  },

  delTmp(params) {
    return ajax.post('/aseapi/console/sysmgr/persistpre/delPersistents', params)
  },

  sendTmp(params) {
    return ajax.post('/aseapi/console/sysmgr/persistpre/reSendMessage', params)
  },

  sendTmpByRange(params) {
    return ajax.post('/aseapi/console/sysmgr/persistpre/reSendByRange', params)
  },

  getSp(uuid) {
    return ajax.get('/aseapi/console/sysmgr/persistpre/viewChainComs', {
      params: {
        uuid: uuid
      }
    })
  },

  getPd(uuid) {
    return ajax.get('/aseapi/console/sysmgr/persistpre/viewProducer', {
      params: {
        uuid: uuid
      }
    })
  },

  getCs(uuid) {
    return ajax.get('/aseapi/console/sysmgr/persistpre/viewConsumer', {
      params: {
        uuid: uuid
      }
    })
  },

  getMs(uuid) {
    return ajax.get('/aseapi/console/sysmgr/persistpre/getMessage', {
      params: {
        uuid: uuid
      }
    })
  },
  getMsTran(uuid) {
    return ajax.get('/aseapi/console/sysmgr/persistpre/transMessage', {
      params: {
        uuid: uuid
      }
    })
  }
}
